// extracted by mini-css-extract-plugin
export var list = "list-module--list--++3pg";
export var paginationBox = "list-module--pagination-box--gg0YL";